import { render, staticRenderFns } from "./cwvDomainsView.vue?vue&type=template&id=492a2efe&%23activator=%7B%20on%20%7D"
import script from "./cwvDomainsView.vue?vue&type=script&lang=ts"
export * from "./cwvDomainsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports